export default "__VITE_ASSET__8nIeuUuW__"